import React from 'react';
import Bg from '../../images/shapes/shape_2kk_section_bg.svg'
import shape from '../../images/shapes/shape_2kk_section_bottom.svg'
import shape3 from '../../images/shapes/shape_coin.webp';
// import shape2 from '../../images/shapes/shape_2.png';


const Hero = () => {

    return (
        <section className="twokk_section section_decoration text-center" style={{ backgroundImage: `url(${Bg})` }}>
            <div className="container">

                <h1 className="hero_title" data-aos="fade-up" data-aos-duration="800">
                    {/*2KK.TEAM*/}
                    <img src="/2kk-logo-white.png" alt={""} width={300}/>
                </h1>

                <div className="resquare-text" data-aos="fade-up" data-aos-duration="900" data-aos-delay="200">
                    Мы не ищем лояльных. <br/>Мы ищем голодных до результата!
                </div>
            </div>
            <div className="shape_bottom">
                <img src={shape} alt="Bottom Line Shape" />
            </div>
            {/*<div className="decoration_item shape_globe">*/}
            {/*    <img src={shape2} alt="Shape Globe" />*/}
            {/*</div>*/}
            <div className="decoration_item shape_coin">
                <img src={shape3} alt="Rocket" />
            </div>
        </section>
    )
}

export default Hero;
